import { motion } from "framer-motion";
import CtaButton from "./CtaButton";

const About = () => {
  return (
    <section className="bg-secondary">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="overflow-hidden"
        >
          <img
            src="https://images.squarespace-cdn.com/content/v1/673a50c415b489151b76ec4c/dd95b53c-b785-4406-ac7e-3be59ee69e13/love_otherwise-52.jpg"
            alt="Love Otherwise venue interior"
            className="w-full h-[500px] lg:min-h-[600px] object-cover"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col justify-center px-8 lg:px-16 py-24 lg:py-32"
        >
          <span className="text-xs tracking-[0.3em] uppercase text-warm-gray font-body mb-4">The Venue</span>
          <h2 className="text-3xl md:text-4xl font-display font-light leading-snug text-foreground">
            Your wedding day, reimagined.
          </h2>
          <div className="mt-6 h-px w-12 bg-champagne" />
          <p className="mt-6 text-base font-body font-light leading-relaxed text-muted-foreground">
            Inside our modern, design-forward venue, a former Legion transformed into an art-driven creative space, we host beautifully intentional celebrations for couples who want something elevated, meaningful, and completely different from the expected.
          </p>
          <div className="mt-8">
            <CtaButton href="/packages" variant="outline" onPinkBg>
              Thoughtfully Curated Packages
            </CtaButton>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
